/* eslint-disable import/order */
/* eslint-disable prettier/prettier */
import { createSelector } from "@reduxjs/toolkit";
import { countryApi } from "./api-slice";
import { IManageBaseListResponse, IManageBaseResponse } from "@bvi/api-interfaces/response/manage-base-data";

export const selectCountry = createSelector(
  (response?: IManageBaseListResponse) => response,
  (response) => (response?.success ? response.payload.data : []),
);

export const selectCountryListResult = () =>
  countryApi.endpoints.getCountryList.select();

export const selectResponse = (data?: IManageBaseResponse) => {
  if (!data?.success) {
    return [];
  }

  return data.payload.data;
};

